<script setup>
import { ref } from 'vue';
import { OnClickOutside } from '@vueuse/components';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import VariablePicker from './VariablePicker.vue';

defineProps({
  modelValue: { type: String, default: '' },
  variables: { type: Array, required: true },
  label: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue', 'openPanel']);

const { t } = useI18n();

const isOpen = ref(false);

const select = key => {
  emit('update:modelValue', key);
  isOpen.value = false;
};
</script>

<template>
  <div class="flex flex-col gap-1 min-w-0">
    <span v-if="label" class="mb-0.5 text-heading-3 text-n-slate-12">
      {{ label }}
    </span>

    <div class="relative flex items-center gap-1">
      <button
        type="button"
        class="flex-1 min-w-0 flex items-center h-10 px-3 rounded-lg outline outline-1 outline-offset-[-1px] outline-n-weak hover:outline-n-slate-6 bg-n-alpha-black2 text-left"
        @click="isOpen = !isOpen"
      >
        <span
          v-if="modelValue"
          class="px-2 py-0.5 rounded text-xs font-mono bg-n-iris-9 text-white truncate"
        >
          {{ modelValue }}
        </span>
        <span v-else class="text-sm text-n-slate-10 truncate">
          {{ t('FLOWS.EDITOR.VARIABLES.SELECT_PLACEHOLDER') }}
        </span>
      </button>

      <Button
        v-tooltip.bottom="t('FLOWS.EDITOR.VARIABLES.MANAGE')"
        icon="i-lucide-settings"
        slate
        ghost
        sm
        class="flex-shrink-0"
        @click="emit('openPanel')"
      />

      <OnClickOutside v-if="isOpen" @trigger="isOpen = false">
        <div
          class="absolute z-10 left-0 top-11 w-72 rounded-lg border border-n-weak bg-n-solid-1 shadow-lg p-2"
        >
          <VariablePicker :variables="variables" @select="select" />
        </div>
      </OnClickOutside>
    </div>
  </div>
</template>
